import type { BelongingsFeatureConfig } from '../../../types/insurances/BelongingsFeatureConfig';

export const belongings: BelongingsFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: false,
            showVariant: true,
            showPackage: false,
            showContractHolder: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
